module.exports = __webpack_public_path__ + "static/media/logo.e9c0bc6d.png";